import { useEffect, useRef, useState } from 'react';
import { formatCountdownHms, msUntilNextMoscowMidnight } from '../../domain';

/** Живой отсчёт до следующей полуночи МСК; `onZero` — один раз, когда осталось 0. */
export function useMoscowCountdown(onZero?: () => void): string {
  const [remainingMs, setRemainingMs] = useState(() =>
    msUntilNextMoscowMidnight(Date.now()),
  );
  const onZeroRef = useRef(onZero);
  onZeroRef.current = onZero;
  const firedZeroRef = useRef(false);

  useEffect(() => {
    function tick() {
      const remaining = msUntilNextMoscowMidnight(Date.now());
      setRemainingMs(remaining);
      if (remaining <= 0 && !firedZeroRef.current) {
        firedZeroRef.current = true;
        onZeroRef.current?.();
      }
    }

    tick();
    const timerId = window.setInterval(tick, 1000);
    return () => {
      window.clearInterval(timerId);
    };
  }, []);

  return formatCountdownHms(remainingMs);
}
